import { $GET, $POST } from '@/api/gateway/gatewayMethods'
import {
  GET_SYSTEM_LOG,
  GET_ACTION_MENU,
  GET_TRANSFER_HISTORY
} from '@/api/endpoint-defines/systemLog'

export const getSystemLog = ({ BodyData }) =>
  $POST({ EndPoint: GET_SYSTEM_LOG, BodyData })

export const getActionMenu = () =>
  $GET({ EndPoint: GET_ACTION_MENU, QueryParameters: null })

export const getTransferHistory = ({ BodyData }) =>
  $POST({ EndPoint: GET_TRANSFER_HISTORY, BodyData })
